// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vision_visionContainer__qS-oL {
  display: flex;
  justify-content: center; 
  align-items: center; 

}
  

  .vision_visionBox__tzb3X {
    width: 100%;
    max-width: 80%;
    height: auto;
    flex-shrink: 0;
    border-radius: 0.5rem;
    background: #C8D3E6;
    padding: 50px;
    display: flex;
    flex-direction: column;
    align-items: center; 
    text-align: center; 
  }
  

  .vision_topic__1z4L3 {
    display: flex;
    align-items: center;
    margin-bottom: 20px; 
    position: relative; 
  }
  
  .vision_topicUnderline__4YLzT {
    height: 3px;
    background: #002566;
    width: 100%; 
    position: absolute; 
    bottom: 0; 
  }
  
  .vision_subTopic__KYdgI {
    color: #414141;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; 
    margin: 0; 
  }
  

  .vision_description__14rJE {
    color: #414141;
    flex-shrink: 0;
    text-align: justify;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0; 
    padding: 0; 
    width: 100%; 
    flex-grow: 1; 
  }
  

  @media (max-width: 768px) {
    .vision_visionContainer__qS-oL {
      flex-direction: column;
      width: 100%;
      gap: 10px;
    }
    
    .vision_visionBox__tzb3X {
      padding: 15px;
    }

    .vision_subTopic__KYdgI {
      font-size: 2rem;
    }

    .vision_description__14rJE {
      font-size: 1rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/aboutUs/vision.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;;EAGE;IACE,WAAW;IACX,cAAc;IACd,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;EACX;;;EAGA;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;EACd;;;EAGA;IACE;MACE,sBAAsB;MACtB,WAAW;MACX,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["\r\n.visionContainer {\r\n  display: flex;\r\n  justify-content: center; \r\n  align-items: center; \r\n\r\n}\r\n  \r\n\r\n  .visionBox {\r\n    width: 100%;\r\n    max-width: 80%;\r\n    height: auto;\r\n    flex-shrink: 0;\r\n    border-radius: 0.5rem;\r\n    background: #C8D3E6;\r\n    padding: 50px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; \r\n    text-align: center; \r\n  }\r\n  \r\n\r\n  .topic {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 20px; \r\n    position: relative; \r\n  }\r\n  \r\n  .topicUnderline {\r\n    height: 3px;\r\n    background: #002566;\r\n    width: 100%; \r\n    position: absolute; \r\n    bottom: 0; \r\n  }\r\n  \r\n  .subTopic {\r\n    color: #414141;\r\n    font-size: 32px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 120%; \r\n    margin: 0; \r\n  }\r\n  \r\n\r\n  .description {\r\n    color: #414141;\r\n    flex-shrink: 0;\r\n    text-align: justify;\r\n    font-size: 22px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n    margin: 0; \r\n    padding: 0; \r\n    width: 100%; \r\n    flex-grow: 1; \r\n  }\r\n  \r\n\r\n  @media (max-width: 768px) {\r\n    .visionContainer {\r\n      flex-direction: column;\r\n      width: 100%;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .visionBox {\r\n      padding: 15px;\r\n    }\r\n\r\n    .subTopic {\r\n      font-size: 2rem;\r\n    }\r\n\r\n    .description {\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visionContainer": `vision_visionContainer__qS-oL`,
	"visionBox": `vision_visionBox__tzb3X`,
	"topic": `vision_topic__1z4L3`,
	"topicUnderline": `vision_topicUnderline__4YLzT`,
	"subTopic": `vision_subTopic__KYdgI`,
	"description": `vision_description__14rJE`
};
export default ___CSS_LOADER_EXPORT___;
